import { render, staticRenderFns } from "./TooltipVcDemo.vue?vue&type=template&id=52ecad2e&scoped=true&"
import script from "./TooltipVcDemo.vue?vue&type=script&lang=js&"
export * from "./TooltipVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./TooltipVcDemo.vue?vue&type=style&index=0&id=52ecad2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ecad2e",
  null
  
)

export default component.exports